import { useCallback, useState } from 'react';

export type UseImportDrawerReturn = {
  /** Whether the import drawer is open. */
  open: boolean;
  /** Close the import drawer. */
  onClose: () => void;
  /** Open the import drawer for 自身の申請 (self); applicant section hidden. */
  onOpenImport: () => void;
  /** Open the import drawer for 代理申請 (proxy); shows ApplicantAndProxyApplicantSection. */
  onOpenImportProxy: () => void;
  /** True when drawer was opened via 代理申請; pass to PaymentRequestImportDrawer as canAgentEntry. */
  isProxyImport: boolean;
};

export function useImportDrawer(): UseImportDrawerReturn {
  const [open, setOpen] = useState(false);
  const [isProxyImport, setIsProxyImport] = useState(false);

  const onClose = useCallback(() => setOpen(false), []);

  const onOpenImport = useCallback(() => {
    setIsProxyImport(false);
    setOpen(true);
  }, []);

  const onOpenImportProxy = useCallback(() => {
    setIsProxyImport(true);
    setOpen(true);
  }, []);

  return {
    open,
    onClose,
    onOpenImport,
    onOpenImportProxy,
    isProxyImport,
  };
}
